import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

import { ReportTableColumn, SummaryItem } from '../../../models';
import { ReportValuePairsComponent } from '../report-value-pairs/report-value-pairs.component';

@Component({
  selector: 'app-report-table',
  templateUrl: './report-table.component.html',
  styleUrl: './report-table.component.scss',
  imports: [NgClass, ReportValuePairsComponent],
})
export class ReportTableComponent {
  public readonly header = input<string>();
  public readonly model = input<any[]>();
  public readonly bodyColumns = input<(any?) => ReportTableColumn[]>();
  public readonly bodySubTableColumnsProperty = input<string>();
  public readonly bodySubTableColumnsProperty2 = input<string>();
  public readonly bodySubTableItemsProperty = input<string>();
  public readonly bodySubTableItemsProperty2 = input<string>();
  public readonly bodySubTableColumns = input<(any?) => ReportTableColumn[]>();
  public readonly bodySubTableColumns2 = input<(any?) => ReportTableColumn[]>();
  public readonly bodySubTableItems = input<(any?) => SummaryItem[]>();
  public readonly bodySubTableItems2 = input<(any?) => SummaryItem[]>();
  public readonly footerModel = input<any>();
  public readonly footerColumns = input<(model: any) => ReportTableColumn[]>();
  public readonly footerSubTableColumnsProperty = input<string>();
  public readonly footerSubTableColumns = input<(any?) => ReportTableColumn[]>();
  public readonly extraBoldLine = input(false);
  public readonly extraLineBreak = input(false);
  public readonly extraSubLineBreak = input(false);

  cssClass(column: ReportTableColumn): any {
    return {
      'width-small': column.widthSmall,
      'text-end': column.textRight,
      'text-center': column.textCenter,
      'text-nowrap': column.textRight || column.textCenter,
    };
  }
}
